import L from "leaflet";

export const DEFAULT_CENTER = [24.0, 45.0];
export const BRANCH_ZONES = {
  "الرياض": { center: [24.7136, 46.6753], radius: 45000, color: "#1B2F8F" },
  "الدمام": { center: [26.3927, 50.03], radius: 35000, color: "#D7262E" },
};
export const STATUS_COLOR = { assigned: "#64748B", in_progress: "#2563EB", on_hold: "#D97706", completed: "#059669" };

export const hasCoords = (c) => c && typeof c.lat === "number" && typeof c.lng === "number";

const URL_PATTERNS = [/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/, /@(-?\d+\.\d+),(-?\d+\.\d+)/, /[?&](?:q|query|ll|destination|center)=(?:loc:)?(-?\d+\.\d+)(?:,|%2C)\s*(-?\d+\.\d+)/, /\/place\/(-?\d+\.\d+),(-?\d+\.\d+)/];

export function parseMapsUrl(url) {
  for (const p of URL_PATTERNS) {
    const m = (url || "").match(p);
    if (m) return { lat: +m[1], lng: +m[2] };
  }
  return null;
}

export function mapsLink(c) {
  if (hasCoords(c)) return `https://www.google.com/maps/search/?api=1&query=${c.lat},${c.lng}`;
  if (c?.maps_url) return c.maps_url;
  const q = [c?.address, c?.area].filter(Boolean).join(" ");
  return q ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}` : "";
}

export const inspectionIcon = (status, selected = false) =>
  L.divIcon({
    className: "",
    iconSize: [30, 30],
    iconAnchor: [15, 28],
    popupAnchor: [0, -26],
    html: `<div style="width:${selected ? 30 : 24}px;height:${selected ? 30 : 24}px;background:${STATUS_COLOR[status] || "#64748B"};border:3px solid #fff;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 6px rgba(0,0,0,.35)"></div>`,
  });

export const agentIcon = (name, stale) =>
  L.divIcon({
    className: "",
    iconSize: [26, 26],
    iconAnchor: [13, 13],
    popupAnchor: [0, -13],
    html: `<div style="width:26px;height:26px;border-radius:50%;background:${stale ? "#94A3B8" : "#D7262E"};color:#fff;display:grid;place-items:center;font:700 12px Cairo,sans-serif;border:2px solid #1B2F8F;box-shadow:0 2px 8px rgba(0,0,0,.35)">${(name || "?").trim().charAt(0)}</div>`,
  });

export function distanceKm(a, b) {
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const x = Math.sin(dLat / 2) ** 2 + Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
}

export const isStale = (loc) => !loc || Date.now() - new Date(loc.updated_at).getTime() > 30 * 60 * 1000;

export function rankAgents(agents, customer) {
  const area = (customer?.area || "").trim();
  const branch = (customer?.branch || "").trim();
  return agents
    .map((a) => ({
      ...a,
      km: hasCoords(customer) && hasCoords(a.location) ? distanceKm(customer, a.location) : null,
      regionMatch: (!!branch && (a.region || "").includes(branch)) || (!!area && (a.region || "").includes(area)),
    }))
    .sort((a, b) => {
      if (a.km != null && b.km != null) return a.km - b.km || a.active_tasks - b.active_tasks;
      if (a.km != null || b.km != null) return a.km != null ? -1 : 1;
      return Number(b.regionMatch) - Number(a.regionMatch) || a.active_tasks - b.active_tasks;
    });
}
